<ifr-page-title pageTitle="'LEFT_PANEL_VISITOR_RECEPTION' | translate "/>
<visitor-reception class="visitor-reception"/>
